var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.092C31 7.757 24.284 1 16 1 7.716 1 1 7.757 1 16.092 1 23.624 6.485 29.868 13.656 31V20.454H9.848v-4.362h3.808v-3.325c0-3.783 2.24-5.872 5.666-5.872 1.64 0 3.358.295 3.358.295v3.714h-1.892c-1.863 0-2.444 1.163-2.444 2.358v2.83h4.16l-.665 4.362h-3.495V31C25.514 29.868 31 23.624 31 16.092z",
    fill: "#1877F2"
  })));
}
export default SvgFacebook;